import Cookies from 'js-cookie';

import destroyStyles from './destroyStyles';

export const whenRenderedCallback = (form) => {
  if (typeof window === 'undefined' || !form) return;
  destroyStyles(form);

  const override = document.getElementById('mktoOverride');
  if (!override) {
    document
      .getElementsByTagName('body')[0]
      .insertAdjacentHTML('beforeend', '<link id="mktoOverride" rel="stylesheet" href="/mktoOverrides.css" />');
  } else {
    override.remove();
    document
      .getElementsByTagName('body')[0]
      .insertAdjacentHTML('beforeend', '<link id="mktoOverride" rel="stylesheet" href="/mktoOverrides.css" />');
  }
  ['mktoForms2BaseStyle', 'mktoForms2ThemeStyle'].forEach((id) => {
    let s = document.getElementById(id);
    if (s) {
      s.remove();
    }
  });
};

export const loadFormCallback = async (form, _isMounted, onSuccess) => {
  if (!form) {
    return;
  }
  const formId = form.getId();
  form.onSuccess(() => {
    if (_isMounted) {
      onSuccess(form);
    }
    return false;
  });
  form.onSubmit(() => {
    if (!!window.FS) {
      window.FS.event('Marketo Form', {
        type: 'Form submitted',
        formID: (formId && formId.toString()) || '',
      });
    }
    if (!!window._6si) {
      try {
        window._6si.send(form.getValues());
      } catch (e) {
        // console.error(e);
      }
    }
  });
  if (!!window.FormsPlus) {
    window.FormsPlus.onSubmitError(function (error) {
      if (!!window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Form submit error',
          formID: (formId && formId.toString()) || '',
          error,
        });
      }
    });
  }
};

export const whenReady = async (form, addHiddenFields, start) => {
  //destroyStyles(form);
  emailValidationHook(form);
  const formId = form.getId();
  if (addHiddenFields) {
    form.addHiddenFields({ mostRecentAssetDownload: document.location.href });
  }
  form.addHiddenFields({ formUrl: document.location.href });
  const originalReferrer = Cookies.get('_fs_oreferrer');
  if (originalReferrer) {
    form.addHiddenFields({ originalReferrer });
  }

  // Hide hidden inputs
  const rows = document.querySelectorAll('.mktoFormRow');
  if (rows && rows.length > 0) {
    rows.forEach((row) => {
      if (row.children[0] && row.children[0].type === 'hidden') {
        row.style.display = 'none';
      }
    });
  }
  const end = performance.now();
  if (!!window.FS) {
    window.FS.event('Marketo Form', {
      type: 'Form Loaded',
      formID: (formId && formId.toString()) || '',
      loadTime: end - start,
    });
  }
};

const emailValidationHook = (form) => {
  form.onValidate(() => {
    if (form.getId() === 1064 && form.vals().Email !== '') {
      // blog subscription
      form.submittable(true);
      return;
    }
    const email = form.vals().Email;
    const freeMail = /^([A-Za-z0-9.!#$%&’*+/=?^_`{|}~-]+@(?!yahoo\.com)(?!hotmail\.com)(?!live\.com)(?!aol\.com)(?!msn\.com)(?!outlook\.com)(?!gmail\.com)(?!bellsouth\.net)(?!icloud\.com)([\w-]+.)+[\w-]{2,8})?$/i;

    if (email && !freeMail.test(email)) {
      if (typeof window !== 'undefined' && !!window.FS) {
        window.FS.event('Marketo Form', {
          type: 'Form validation issues',
          freeTried: email,
          formID: form.getId().toString(),
        });
      }
      form.submittable(false);
      const emailElem = form.getFormElem().find('#Email');
      form.showErrorMessage('Must be a business email.', emailElem);
    } else {
      form.submittable(true);
    }
  });
};
